var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickWhiteMedium = function SvgTickWhiteMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17 2.681 5.791 14.45 0 8.37l2.554-2.682 3.237 3.4L14.446 0z",
    clipRule: "evenodd"
  })));
};
export { SvgTickWhiteMedium as ReactComponent };
export default __webpack_public_path__ + "images/tick_white_medium.svg";